import React from 'react';
import Input from '../../../components/ui/Input';

const GeneralSettings = ({ config, onUpdate }) => {
  const handleInputChange = (field, value) => {
    onUpdate({ [field]: value });
  };

  const handleTagsChange = (value) => {
    // Convert comma-separated string to array
    const tagsArray = value
      ?.split(',')
      ?.map(tag => tag?.trim())
      ?.filter(tag => tag?.length > 0);
    
    onUpdate({ tags: tagsArray || [] });
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-foreground mb-4">Agent-Grundeinstellungen</h3>
        <div className="space-y-4">
          <Input
            label="Agent-Name *"
            value={config?.name || ''}
            onChange={(e) => handleInputChange('name', e?.target?.value)}
            placeholder="z.B. Kundenservice Bot"
            required
            className="max-w-md"
          />
          
          <Input
            label="Anzeigename"
            value={config?.display_name || ''}
            onChange={(e) => handleInputChange('display_name', e?.target?.value)}
            placeholder="z.B. Max Mustermann"
            className="max-w-md"
          />
          
          <Input
            label="Support-E-Mail"
            type="email"
            value={config?.support_email || ''}
            onChange={(e) => handleInputChange('support_email', e?.target?.value)}
            placeholder="support@beispiel.com"
            className="max-w-md"
          />
          
          <Input
            label="Tags"
            value={config?.tags?.join(', ') || ''}
            onChange={(e) => handleTagsChange(e?.target?.value)}
            placeholder="z.B. kundenservice, verkauf, support"
            description="Komma-getrennte Tags für bessere Organisation"
            className="max-w-md"
          />
        </div>
      </div>
      
      {config?.tags?.length > 0 && (
        <div>
          <p className="text-sm text-muted-foreground mb-2">Aktuelle Tags:</p>
          <div className="flex flex-wrap gap-2">
            {config?.tags?.map((tag, index) => (
              <span
                key={index}
                className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-primary/10 text-primary"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default GeneralSettings;